import { useEffect, useState } from "react";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _EcmDocument, _QualityInspectionProductRamdom, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { toast } from "react-toastify";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../theme/Component/Modal";
import { SelectTHConstantsValue } from "../../../../bpm/config/Componentes/SelectTHConstantsValue";
import { InputDate } from "../../../../theme/Input/InputDate";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { QualityInspectionSample } from "./QualityInspectionSample/QualityInspectionSample";
import { FileService } from "../../../../../core/services/FileService";
import usePaginator from "../../../../theme/Component/usePaginator";
import { SingPanelEditor } from "../../../../contabilidad/SignAndApprovalPanel/SingPanelEditor";
import { PdfDocuments } from "../../../../documents/PdfDocuments";
import { SelectProductEditor } from "../../../ManufacturingStandars/Components/SelectProductEditor";
import { DropDown } from "../../../../theme/Component/DropDown";
import { ExportXLSL } from "../../../../theme/Component/ExportXLSX";

interface ComponentData {
    isModal?: boolean;
    _ProductionOrder?: any;
    isReport?: boolean;
}

interface formData {
    FromDate: any;
    UptoDate: any;
    Turn: number;
    IDProduct: number;
    IDConcept: number;
    State: number;
}

export const QualityInspectionProductRamdom = ({ _ProductionOrder, isModal, isReport }: ComponentData) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityInspectionProductRamdom);
    const fileservice = new FileService();
    const paginator = usePaginator();
    const signed = useDataBean(_EcmDocument);

    const [form, setForm] = useState<Partial<formData>>({
        State: 1
    })

    const modal = useModal("", MODAL_LG)
    const modalItems = useModal("", MODAL_LG)
    const modalChange = useModal("", MODAL_SM);
    const modalDocument = useModal("Cargar Documento Firmado", MODAL_md);
    const modalSeeDocument = useModal("Ver Documento", MODAL_XL);

    useEffect(() => {
        if (_ProductionOrder.IDProductionOrder) {
            getLista();
        } else if (isReport) {
            getLista();
        }
    }, [_ProductionOrder, paginator.page])

    const getLista = () => {
        let props: any = {
            IDProductionOrder: _ProductionOrder.IDProductionOrder,
            IDProduct: _ProductionOrder.IDProduct,
        }

        if (form.State) props.State = form.State;
        if (form.IDConcept) props.IDConcept = form.IDConcept;
        if (form.IDProduct) props.IDProduct = form.IDProduct;
        if (form.Turn) props.CodeTurn = form.Turn;

        instance.getQualityInspectionProductRamdomRender(paginator.page, 15, props, form.FromDate, form.UptoDate).then(
            (resp) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const create = () => {
        setBean({
            IDProduct: _ProductionOrder.IDProduct,
            IDProductionOrder: _ProductionOrder.IDProductionOrder,
            State: 1,
            ReviewDate: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID(),
        });
        modal.open("Agregar Inspección de Producto Terminado Aleatoria")
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate() && (!isReport), icono: 'ri-file-add-line', evento: create }
    ]

    const head = [
        { title: 'ID', property: 'IDQualityInspectionProductRamdom', visible: true },
        { title: 'Turno', property: 'CodeTurnName', visible: true },
        { title: 'Norma o Especificación Tecnica', property: 'NameTechnicalRule', visible: true },
        { title: 'Producto', property: 'ProductDescription', visible: true },
        { title: 'Tamaño del Lote', property: 'SizeLot', visible: true },
        { title: 'Tamaño de la Muestra', property: 'SizeSample', visible: true },
        { title: 'Numero de Aceptación', property: 'NumberAceptance', visible: true },
        { title: 'Numero de Rechazo', property: 'NumberRejection', visible: true },
        { title: 'No. Acordes', property: 'According', visible: true },
        { title: 'No. No Acordes', property: 'NotAccording', visible: true },
        { title: 'Concepto', property: 'ConceptName', visible: true },
        { title: 'Observaciones', property: 'Observation', visible: true },
        { title: 'Fecha de revisión', property: 'ReviewDate', visible: true },
    ]

    const [confirmAction, setConfirmAction] = useState<() => void>(() => () => { });

    const openConfirm = (text: string, fn: () => void) => {
        setConfirmAction(() => fn);
        modalChange.open(text)
    };

    const changeStateItem = (newState: number) => {
        let x = { ...bean, State: newState };


        editaItem(x);
    };

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit() && (!isReport), evento: () => { modal.open("Editar Inspección de Producto Terminado Aleatoria") } },
            { titulo: 'Solicitar Aprobaciones', icono: 'mdi mdi-signature-text', visible: _single.canEdit() && (!isReport), evento: () => { modalDocument.open() } },
            { titulo: 'Ver Documento', icono: 'mdi mdi-folder-eye-outline', visible: bean.IDDocument, evento: () => { modalSeeDocument.open() } },
            { titulo: 'Muestras de la Revisión', icono: 'ri-list-check', visible: _single.canEdit(), evento: () => { modalItems.open("Muestras") } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete() && bean.State == 1 && (!isReport), evento: () => { openConfirm("Confirmar Eliminación", () => changeStateItem(3)) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const editaItem = (obj: any) => {
        instance.updateQualityInspectionProductRamdom(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalChange.close();
                modalDocument.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "IDConcept", "NumberRejection", "NumberAceptance", "SizeSample", "SizeLot"
        ];

        if (bean.IDQualityInspectionProductRamdom) {
            requiredFields.push("NotAccording", "According")
        }

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };


    const validateDataSigned = () => {
        if (!signed.bean.IDSignPanel) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            createEcmDocumentForFlowControl();
        }
    }

    const createEcmDocumentForFlowControl = () => {

        const Obs = `Durante la inspección aleatoria del producto ${bean.ProductDescription}, se tomo el tamño de muestra de ${bean.SizeSample} de un tamaño de lote ${bean.SizeLot}, con un numero de aceptación de ${bean.NumberAceptance} muestras y ${bean.NumberRejection} de rechazo, por el concepto de ${bean.ConceptName}, donde dio como resultado ${bean.According} muestras acordes y ${bean.NotAccording} muestras no acordes`

        signed.instance.createEcmDocumentForFlowControl(signed.bean.IDSignPanel, _single.getAccountID(), Obs, null, null, null, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                if (resp.IDDocument > 0) {
                    signed.instance.fireSigningDocumentFlow(resp.IDDocument, resp.Mnemonic, resp.DocumentDate, signed.bean.IDSignPanel, _single.getAccountID()).then(
                        (resp: any) => {
                            toast.success(resp);
                            console.log(resp)
                        }
                    ).catch(
                        err => {
                            toast.error("No se pudo iniciar proceso de firmas")
                        }
                    )
                    editaItem({ ...bean, IDDocument: resp.IDDocument, DocumentDate: resp.DocumentDate })
                } else {
                    toast.error("No se genero documentoa firmar")
                }
            }).catch(
                err => { toast.error(err) }
            )
    }

    const modalGraph = useModal("Reporte Excel", MODAL_SM);
    const [listaExport, setListaExport] = useState<any[]>([]);

    const getListaExport = () => {
        let props: any = {
            IDProductionOrder: _ProductionOrder.IDProductionOrder,
            IDProduct: _ProductionOrder.IDProduct,
        }

        if (form.State) props.State = form.State;
        if (form.IDConcept) props.IDConcept = form.IDConcept;
        if (form.IDProduct) props.IDProduct = form.IDProduct;
        if (form.Turn) props.CodeTurn = form.Turn;

        instance.getQualityInspectionProductRamdomRender(1, 15 * paginator.pages, props, form.FromDate, form.UptoDate).then(
            (resp) => {
                setListaExport(resp.List);
                modalGraph.open();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Reporte Excel', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            getListaExport();
                        }
                    }} />
                </div>
            </div>
        )
    }

    const baseComponent = () => {
        return (
            <div className="row">
                <div className="col-md-4">
                    <InputDate name="" value={form.FromDate} label="Fecha desde" setDate={(e) => { setForm({ ...form, FromDate: e }) }} />
                </div>
                <div className="col-md-4">
                    <InputDate name="" value={form.UptoDate} label="Fecha hasta" setDate={(e) => { setForm({ ...form, UptoDate: e }) }} />
                </div>
                <div className="col-md-4">
                    <SelectTHConstantsValue label="Concepto" code={908} onChange={(e) => { setForm({ ...form, IDConcept: e }) }} value={form.IDConcept} />
                </div>
                <div className="col-md-4">
                    <SelectTHConstantsValue label="Turno" code={904} onChange={(e) => { setForm({ ...form, Turn: e }) }} value={form.Turn} />
                </div>
                <div className="col-md-4">
                    <SelectProductEditor label="Producto" value={form.IDProduct} onChange={(e) => { setForm({ ...form, IDProduct: e.IDProduct }) }} />
                </div>
                <div className="col-md-4">
                    <label>Estado</label>
                    <select value={form.State} onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : null
                        setForm({ ...form, State: value })
                    }} className="form-select">
                        <option value="">...</option>
                        <option value="1">Creado</option>
                        <option value="3">Eliminado</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <BasicButton useMargin eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} />
                </div>
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        headButtons={buttons()}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        pageTop={paginator.page}
                        next={paginator.next}
                        back={paginator.back}
                        records={paginator}
                    />
                </div>
                <div className="col-md-12">

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('WorkShift') ? 'has-error' : ''}`} >Fecha de Revisión</label>
                                <InputDate name="" value={bean.ReviewDate} setDate={(e) => { setBean({ ...bean, ReviewDate: e }) }} label=" " />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('CodeTurn') ? 'has-error' : ''}`} >Turno de Trabajo</label>
                                <SelectTHConstantsValue label=" " code={904} onChange={(e) => { setBean({ ...bean, CodeTurn: e }) }} value={bean.CodeTurn} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('NameTechnicalRule') ? 'has-error' : ''}`} >Norma o Especificación Técnica</label>
                                <input type="text" className="form-control" value={bean.NameTechnicalRule} onChange={(e) => { setBean({ ...bean, NameTechnicalRule: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDConcept') ? 'has-error' : ''}`} >Concepto</label>
                                <SelectTHConstantsValue label=" " code={908} onChange={(e) => { setBean({ ...bean, IDConcept: e }) }} value={bean.IDConcept} />
                            </div>

                            <div className="col-12"><hr /></div>

                            <h4>Plan de Muestreo</h4>

                            <div className="col-md-6">
                                <label className={`${missingFields.includes('SizeLot') ? 'has-error' : ''}`} >Tamaño del Lote</label>
                                <input type="number" className="form-control" value={bean.SizeLot} onChange={(e) => { setBean({ ...bean, SizeLot: e.target.value ? Number(e.target.value) : null }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${missingFields.includes('SizeSample') ? 'has-error' : ''}`} >Tamaño de la Muestra</label>
                                <input type="number" className="form-control" value={bean.SizeSample} onChange={(e) => { setBean({ ...bean, SizeSample: e.target.value ? Number(e.target.value) : null }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${missingFields.includes('NumberAceptance') ? 'has-error' : ''}`} >Número de Aceptación</label>
                                <input type="number" className="form-control" value={bean.NumberAceptance} onChange={(e) => { setBean({ ...bean, NumberAceptance: e.target.value ? Number(e.target.value) : null }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${missingFields.includes('NumberRejection') ? 'has-error' : ''}`} >Número de Rechazo</label>
                                <input type="number" className="form-control" value={bean.NumberRejection} onChange={(e) => { setBean({ ...bean, NumberRejection: e.target.value ? Number(e.target.value) : null }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${missingFields.includes('According') ? 'has-error' : ''}`} >Conformes</label>
                                <input type="number" className="form-control" value={bean.According} onChange={(e) => { setBean({ ...bean, According: e.target.value ? Number(e.target.value) : null }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${missingFields.includes('NotAccording') ? 'has-error' : ''}`} >No Conformes</label>
                                <input type="number" className="form-control" value={bean.NotAccording} onChange={(e) => { setBean({ ...bean, NotAccording: e.target.value ? Number(e.target.value) : null }) }} />
                            </div>


                            <div className="col-12"><hr /></div>

                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Observation') ? 'has-error' : ''}`} >Observaciones</label>
                                <textarea value={bean.Observation} onChange={(e) => { setBean({ ...bean, Observation: e.target.value }) }} className="form-control" />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalItems.modal} updateModal={modalItems.setModal} >
                        <QualityInspectionSample QualityInspectionProdcutRamdom={bean} />
                    </Modal>

                    <Modal modal={modalDocument.modal} updateModal={modalDocument.setModal} eventModal={() => { validateDataSigned() }}  >
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('IDSignPanel') ? 'has-error' : ''}`}>Panel de Firma</label>
                            <SingPanelEditor idSelector={signed.bean.IDSignPanel} label=" " onChange={(e) => { signed.setBean({ ...signed.bean, "IDSignPanel": e }) }} />
                        </div>
                    </Modal>

                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <div className="row">
                            <div className="col">
                                {lista.length > 0 &&
                                    <ExportXLSL customName={"Aleatorio"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                        _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalSeeDocument.modal} updateModal={modalSeeDocument.setModal}   >
                        <PdfDocuments documentLocation={bean.IDDocument} date={bean.DocumentDate} mnemonic="ECM" />
                    </Modal>

                    <ModalConfirm modal={modalChange.modal} updateModal={modalChange.setModal} eventModal={() => { confirmAction() }}>
                        <strong>¿Desea Continuar con la accion?</strong>
                    </ModalConfirm>
                </div>
            </div>
        )
    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Calidad - Procedimientos">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}